export default __webpack_public_path__ + "static/media/pearcey-foundation.1ad3586e.svg";